import { render, staticRenderFns } from "./CertifGrad.vue?vue&type=template&id=75334d56&scoped=true&"
import script from "./CertifGrad.vue?vue&type=script&lang=js&"
export * from "./CertifGrad.vue?vue&type=script&lang=js&"
import style0 from "./CertifGrad.vue?vue&type=style&index=0&id=75334d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75334d56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
